import { BaseSystem } from './base_system';
import { REFERENCE_FPS, Vector2 } from '@cgs/wge';
import { ComponentIndex } from '../entities_engine/component_index';
import { EntitiesEngine } from '../entities_engine/entities_engine';
import { EntityCacheHolder } from '../game_components/entity_cache_holder';
import { ComponentNames } from '../entity_components/component_names';
import { Entity } from '../entities_engine/entity';

export class MovementSystem extends BaseSystem {
  positionIndex: ComponentIndex;
  speedIndex: ComponentIndex;

  constructor(engine: EntitiesEngine, entityCacheHolder: EntityCacheHolder) {
    super(engine, entityCacheHolder);
  }

  getIndexesForFilter(): ComponentIndex[] {
    this.positionIndex = this.engine.getComponentIndex(ComponentNames.Position);
    this.speedIndex = this.engine.getComponentIndex(ComponentNames.Speed);
    return [this.positionIndex, this.speedIndex];
  }

  processEntity(entity: Entity, dt: number): void {
    const pos = entity.get<Vector2>(this.positionIndex);
    const speed = entity.get<Vector2>(this.speedIndex);
    const timeFactor = dt * REFERENCE_FPS;
    pos.x += speed.x * timeFactor;
    pos.y += speed.y * timeFactor;
    entity.set(this.positionIndex, pos);
  }
}
